// !Do not remove the Layout import
import Layout from '@layouts/VerticalLayout'
import NewLayout from '@layouts/new-VerticalLayout'
import { useFeatureGate } from '../_hooks/useFeatureGate'

// ** Components
// import CustomMenu from './components/Menu'
// import CustomNavbar from './components/Navbar'
// import CustomFooter from './components/Footer'

const VerticalLayout = (props) => {
  const { value: centrali3_0 } = useFeatureGate('centrali3_0', false)

  return centrali3_0 ? (
    <NewLayout {...props}>{props.children}</NewLayout>
  ) : (
    <Layout
      // menu={props => <CustomMenu {...props} />}
      // navbar={props => <CustomNavbar {...props} />}
      // footer={props => <CustomFooter {...props} />}
      {...props}>
      {props.children}
    </Layout>
  )
}

export default VerticalLayout
